<template>
  <div :class="classes">
    <div v-if="label || $slots['label-end']"
      class="field__head">
      <label v-if="shape !== 'switch'"
        class="field__label"
        :for="id">{{ label }}<em v-if="required"
          aria-hidden="true">*</em></label>
      <!-- A switch carries its label inside; the empty line keeps it level with labelled fields beside it. -->
      <span v-else
        class="field__label"
        aria-hidden="true">&nbsp;</span>
      <span v-if="$slots['label-end']"
        class="field__label-end"><slot name="label-end" /></span>
    </div>

    <slot v-if="shape === 'bare'" />
    <component :is="shape === 'switch' ? 'label' : 'div'"
      v-else
      class="field__frame">
      <!-- A changed icon (e.g. the spinner while saving) cross-fades with the old one in the same circle. -->
      <span v-if="icon"
        class="field__icon"
        aria-hidden="true">
        <Transition name="field-icon">
          <i :key="icon"
            :class="icon" />
        </Transition>
      </span>
      <slot />
      <span v-if="unit"
        class="field__unit">{{ unit }}</span>
      <i v-if="readonly"
        class="field__lock fa-solid fa-lock"
        aria-hidden="true" />
      <slot name="action" />
    </component>

    <p v-if="error || hint || count || $slots.hint"
      :id="id + '-hint'"
      :class="['field__hint', { 'field__hint--error': error }]">
      <span v-if="error">{{ error }}</span>
      <span v-else><slot name="hint">{{ hint }}</slot></span>
      <span v-if="count"
        class="field__count">{{ count }}</span>
    </p>
  </div>
</template>

<script>
export default {
  name: 'field-shell',
  props: {
    id: { type: String, required: true },
    label: { type: String, default: '' },
    required: { type: Boolean, default: false },
    icon: { type: String, default: '' },
    unit: { type: String, default: '' },
    hint: { type: String, default: '' },
    error: { type: String, default: '' },
    invalid: { type: Boolean, default: false },
    count: { type: String, default: '' },
    size: { type: String, default: 'md' },
    // frame: the capsule around an input; area: the same, for a textarea; switch: the capsule is the toggle; bare: no frame.
    shape: { type: String, default: 'frame' },
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
  },
  computed: {
    classes() {
      return ['field', `field--${this.size}`, `field--${this.shape}`, {
        'field--invalid': this.error || this.invalid,
        'field--disabled': this.disabled,
        'field--readonly': this.readonly,
        'field--icon': this.icon,
      }]
    },
  },
}
</script>

<style lang="scss" src="./field.scss"></style>
